import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiUrls } from "src/app/services/ApiUrls";
import { ProjectModel } from "src/app/model/ProjectModel";

@Component({
  selector: "app-secure-project-au",
  templateUrl: "./project-au.component.html",
  styleUrls: ["./project-au.component.scss"],
})
export class ProjectAUComponent implements OnInit {
  projectKey: number;
  pageMode: string;
  projectModel : ProjectModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  projectImagesUrl: string;
  unsavedBuildingImages: string[] = [];
  unsavedFloorPlans: string[] = [];
  unsavedLocationPlans: string[] = [];
  isLoading: boolean = false;
  isPrinting: boolean = false;
  
  boardList: {[key: number]: string};
  amenityList: [{
    amenitySystemConfigKey: number,
    amenityConfigKey: string,
    amenityConfigValue: string,
    amenityConfigImage: string
  }];

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.projectImagesUrl = ApiUrls.projectImagesUrl;
    this.masterService
    .initProjectForm()
    .subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.boardList = data.boardList;
        this.amenityList = data.amenityList;

        this.route.params.subscribe((params: Params) => {
          this.projectKey = +params["key"];      
          if(this.projectKey) {
            this.masterService
            .getProjectBykey(this.projectKey)
            .subscribe((data: any) => {
              if(data.status === 'SUCCESS') {
                this.projectModel = data;
                this.pageMode = "Edit";
                
                this.form.patchValue({
                  boardKey: {key: this.projectModel.boardId, value: this.projectModel.boardCode + 
                    " - "+ this.projectModel.boardName},
                  projectCode: this.projectModel.projectCode,
                  projectName: this.projectModel.projectName,
                  taluka: this.projectModel.taluka,
                  projectAddress: this.projectModel.projectAddress,
                  latitude: this.projectModel.latitude,
                  longitude: this.projectModel.longitude,
                  ctsNo: this.projectModel.ctsNo,
                  mahareraNo: this.projectModel.mahareraNo,
                });

                let selectedAmenities: FormArray = this.form.get('amenities') as FormArray;
                this.projectModel.amenities.forEach(rf => {
                  selectedAmenities.push(new FormControl(rf.key));
                });
              }
              else {
                this.masterService.errorToast(data.errorMessage);
              }
            });
          }
          else {
            this.pageMode = "Add";
          }
        });
      }
      else {
        this.errorToast(data.errorMessage, 5*1000);
      }
    });
    this.form = new FormGroup({
      boardKey: new FormControl(null, [Validators.required]),
      projectCode: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      projectName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      taluka: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      projectAddress: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      latitude: new FormControl(null, [Validators.required, Validators.min(0)]),
      longitude: new FormControl(null, [Validators.required, Validators.min(0)]),
      ctsNo: new FormControl(null, [Validators.maxLength(255)]),
      mahareraNo: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      amenities: new FormArray([])
    });
  }

  onSubmit() {
    if (this.form.valid) {
      if(!(+this.form.value.boardKey?.key > 0)) {
        this.errorToast('Please select Board');
        this.isSubmitDisabled = false;
        return;
      }
      if(this.pageMode === 'Add') {
        this.save();
      }
      else {
        this.update();
      }
    } 
    else {
      this.isSubmitDisabled = false;
    }
  }

  async save() {
    this.masterService
    .saveProject({
      boardId: this.form.value.boardKey?.key,
      projectCode: this.form.value.projectCode,
      projectName: this.form.value.projectName,
      taluka: this.form.value.taluka,
      projectAddress: this.form.value.projectAddress,
      latitude: this.form.value.latitude,
      longitude: this.form.value.longitude,
      ctsNo: this.form.value.ctsNo,
      mahareraNo: this.form.value.mahareraNo,
      amenities: this.form.value.amenities,
      savedBuildingImages: this.projectModel?.buildingImages,
      savedFloorPlanImages: this.projectModel?.floorPlanImages,
      savedLocationImages: this.projectModel?.locationImages,
      unsavedBuildingImages: this.unsavedBuildingImages,
      unsavedFloorPlans: this.unsavedFloorPlans,
      unsavedLocationPlans: this.unsavedLocationPlans,
    })
    .subscribe((data: any) => {
        if(data.status === 'SUCCESS') {
          this.successToast();
          this.router.navigate(["/secure", "project", "list"]);
        }
        else {
          this.isSubmitDisabled = false;
          this.errorToast(data.errorMessage);
        }
      }, error => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5*1000);
      });  
  }

  async update() {
    this.masterService
    .updateProject(this.projectKey, {
      boardId: this.form.value.boardKey?.key,
      projectCode: this.form.value.projectCode,
      projectName: this.form.value.projectName,
      taluka: this.form.value.taluka,
      projectAddress: this.form.value.projectAddress,
      latitude: this.form.value.latitude,
      longitude: this.form.value.longitude,
      ctsNo: this.form.value.ctsNo,
      mahareraNo: this.form.value.mahareraNo,
      amenities: this.form.value.amenities,
      savedBuildingImages: this.projectModel.buildingImages,
      savedFloorPlanImages: this.projectModel.floorPlanImages,
      savedLocationImages: this.projectModel.locationImages,
      unsavedBuildingImages: this.unsavedBuildingImages,
      unsavedFloorPlans: this.unsavedFloorPlans,
      unsavedLocationPlans: this.unsavedLocationPlans,
    }).subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.successToast();
        this.router.navigate(["/secure", "project", "list"]);
      }
      else {
        this.isSubmitDisabled = false;
        this.errorToast(data.errorMessage);
      }
    }, error => {
      this.isSubmitDisabled = false;
      console.log(error);
      this.errorToast(error.error.errorMessage, 5*1000);
    });    
  }

  onBuildingImageSelect(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.unsavedBuildingImages.push(reader.result.toString());
    };
  }

  deleteBuildingImage(type: string, i: number) {
    if(type === 'SAVED') {
      this.projectModel.buildingImages.splice(i, 1);
    }
    else {
      this.unsavedBuildingImages.splice(i, 1);
    }
  }

  onFloorPlanSelect(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.unsavedFloorPlans.push(reader.result.toString());
    };
  }

  deleteFloorPlan(type: string, i: number) {
    if(type === 'SAVED') {
      this.projectModel.floorPlanImages.splice(i, 1);
    }
    else {
      this.unsavedFloorPlans.splice(i, 1);
    }
  }

  onLocationPlanSelect(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.unsavedLocationPlans.push(reader.result.toString());
    };
  }

  deleteLocationPlan(type: string, i: number) {
    if(type === 'SAVED') {
      this.projectModel.locationImages.splice(i, 1);
    }
    else {
      this.unsavedLocationPlans.splice(i, 1);
    }
  }

  showBoard(o1: any, o2: any) {
    console.log(o1, o2);
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  onCheckboxChange(e: any) {
    const selectedAmenities: FormArray = this.form.get('amenities') as FormArray;
    if (e.target.checked) {
      selectedAmenities.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      selectedAmenities.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          selectedAmenities.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  async successToast() {
    await this._snackBar.open(
      "Project saved successfully.",
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
  
}